const impactCls = (label) => (
  label === "LOW" ? "bg-emerald-50 text-emerald-700 border-emerald-200"
  : label === "MED" ? "bg-amber-50 text-amber-700 border-amber-200"
  : "bg-red-50 text-[#D0021B] border-red-200"
);

/** Single ranked leave row in the Approver Coach panel. */
export default function CoachRow({ it, idx }) {
  return (
    <div
      data-testid={`approver-coach-row-${idx}`}
      className={`border ${idx === 0 ? "border-[#FF3E00]" : "border-zinc-200"} bg-white px-3 py-2 flex flex-col md:flex-row md:items-center gap-2 md:gap-4`}
    >
      <div className="flex items-center gap-2 min-w-[60px]">
        <div className="w-7 h-7 flex items-center justify-center bg-zinc-950 text-white font-mono text-[10px] font-bold">#{idx + 1}</div>
        <span className={`font-mono text-[10px] tracking-wider px-1.5 py-0.5 border ${impactCls(it.impact_label)}`}>
          {it.impact_label}
        </span>
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-bold truncate">{it.employee_name}</div>
        <div className="text-[10px] font-mono text-zinc-500">
          {it.department} · {it.type.toUpperCase()}
          {it.half_day ? ` · ${it.half_day.toUpperCase()} ½` : ""}
          {" · "}
          <span className="tnum">{it.start_date} → {it.end_date}</span>
          {" · "}
          <span className="tnum">{it.days_requested}d</span>
        </div>
      </div>
      <div className="flex items-center gap-3 flex-wrap text-[10px] font-mono text-zinc-600">
        <span className={it.days_until_start <= 2 ? "text-[#FF3E00] font-bold" : ""}>
          {it.days_until_start <= 0 ? "STARTED" : `IN ${it.days_until_start}D`}
        </span>
        <span>{it.conflict_count} CFL</span>
        <span>BAL {it.balance_left}D</span>
        <span className="font-bold text-zinc-950 tnum">{it.approve_score}/100</span>
      </div>
      <div className="text-[10px] text-zinc-500 italic md:max-w-xs md:text-right md:pl-2 md:border-l md:border-zinc-200">
        {it.reason}
      </div>
    </div>
  );
}
